import { buildPriceBreakdown, LegType, PriceLike } from "@/features/delivery/lib/deliveryPresentation.js";

interface DeliveryPriceBreakdownProps {
  price?: PriceLike | null;
  currencySymbol: string;
  type?: LegType;
}

/**
 * Renders the delivery price breakdown. Line composition and money formatting
 * are delegated to the tested buildPriceBreakdown helper (SRP).
 */
export default function DeliveryPriceBreakdown({ price, currencySymbol, type = "pickup" }: DeliveryPriceBreakdownProps) {
  if (!price) {
    return null;
  }

  const breakdown = buildPriceBreakdown(price, currencySymbol, type);

  return (
    <div className="rounded-md bg-neutral-50 p-3 text-sm">
      {breakdown.lines.map((line) => (
        <div key={line.key} className="flex justify-between py-0.5">
          <span>{line.label}</span>
          <strong>{line.value}</strong>
        </div>
      ))}
      <div className="mt-2 flex justify-between border-t pt-2 text-base">
        <span>{breakdown.total.label}</span>
        <strong>{breakdown.total.value}</strong>
      </div>
    </div>
  );
}
